import * as Three from 'three';
import React from 'react';
import { lineBreakWord } from '../../../common/functions/helperFunctions';

const WIDTH = 60;
const DEPTH = 60;
const HEIGHT = 40;

export default {
    name: 'gas-board',
    prototype: 'items',

    info: {
        tag: ['metal'],
        title: 'GRT',
        description: 'Gas Board',
        image: require('./gas-board.PNG')
    },

    properties: {
        altitude: {
            label: 'altitude',
            type: 'length-measure',
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        },
        width: {
            label: 'width',
            type: 'length-measure',
            defaultValue: {
                length: 100,
                unit: 'cm'
            }
        },
        depth: {
            label: 'depth',
            type: 'length-measure',
            defaultValue: {
                length: 60,
                unit: 'cm'
            }
        }
    },

    render2D: function (element, layer, scene) {
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
        let width = element.properties.get('width').get('length');
        let depth = element.properties.get('depth').get('length');
        let angle = element.rotation + 90;
        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }
        let desc = lineBreakWord(element.desc, 20);

        return (
            <g transform={`translate(${-width / 2},${-depth / 2})`}>
                <rect key="1" x='0' y='0' width={width} height={depth} style={style} />
                <rect key="2" x='10' y='10' width={width - 20} height={depth - 20} style={style} />
                <text key="3" x="0" y="0"
                    transform={`translate(${width / 2}, ${textRotation === 0 ? -5 : depth + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene) {
        let angle = element.rotation + 90;
        let textRotation = 0;
        let desc = lineBreakWord(element.desc, 20);
        let style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" }
        let styleRight = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#ccc" }
        let styleFront = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "#eee" }

        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        return (
            <g transform={`translate(${-WIDTH / 1.2}, -100)`}>
                <rect key="8" x="0" y={-HEIGHT} width={WIDTH} height={HEIGHT} style={styleFront} />
                <g transform={`scale(1, 0.5) skewX(27)`}>
                    <rect key="1" x="0" y="0" width={WIDTH} height={DEPTH} style={style} />
                    <rect key="2" x="7" y="7" width={WIDTH - 14} height={DEPTH - 14} style={style} />
                </g>
                <g transform={`translate(${WIDTH}, 0) skewY(45)`}>
                    <rect key="8" x="0" y={-HEIGHT} width={WIDTH / 2} height={HEIGHT} style={styleRight} />
                </g>
                <text key="10" x="0" y="0"
                    transform={`translate(${WIDTH + 5}, ${textRotation === 0 ? -5 : DEPTH + 5}) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "left", fontSize: "11px" }}>
                    {desc.map((r, index) => <tspan key={index + 'desc'} x="0" y={12 * (index + 1)}>{r}</tspan>)}
                </text>
            </g>
        )
    }
};
